/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_NewInputs */

const en_val_new = /** @type {(inputs: Val_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

const es_val_new = /** @type {(inputs: Val_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo`)
};

const fr_val_new = /** @type {(inputs: Val_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuf`)
};

const de_val_new = /** @type {(inputs: Val_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu`)
};

const ja_val_new = /** @type {(inputs: Val_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新品`)
};

const zh_val_new = /** @type {(inputs: Val_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全新`)
};

const ar_val_new = /** @type {(inputs: Val_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جديد`)
};

const id_val_new = /** @type {(inputs: Val_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baru`)
};

const it_val_new = /** @type {(inputs: Val_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo`)
};

const ru_val_new = /** @type {(inputs: Val_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новое`)
};

const pt_val_new = /** @type {(inputs: Val_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo`)
};

const ko_val_new = /** @type {(inputs: Val_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 상품`)
};

/**
* | output |
* | --- |
* | "New" |
*
* @param {Val_NewInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_new = /** @type {((inputs?: Val_NewInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_NewInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_new(inputs)
	if (locale === "es") return es_val_new(inputs)
	if (locale === "fr") return fr_val_new(inputs)
	if (locale === "de") return de_val_new(inputs)
	if (locale === "ja") return ja_val_new(inputs)
	if (locale === "zh") return zh_val_new(inputs)
	if (locale === "ar") return ar_val_new(inputs)
	if (locale === "id") return id_val_new(inputs)
	if (locale === "it") return it_val_new(inputs)
	if (locale === "ru") return ru_val_new(inputs)
	if (locale === "pt") return pt_val_new(inputs)
	return ko_val_new(inputs)
});